import { useState } from 'react';
import WebsiteService from './WebsiteService';

function useManageWebsites() {
    const [websites, setWebsites] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshWebsites = async () => {
        setIsLoading(true);
        try {
            const response = await WebsiteService.getWebsites();
            setWebsites(response.data);
            console.log(response)
            setError(null);
        } catch (err) {
            console.log(err)
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addWebsite = async (websiteData) => {
        let result = true
        setIsLoading(true);
        try {
            await WebsiteService.addWebsite(websiteData);
            refreshWebsites();
        } catch (err) {
            result = false
            setError(err.response.data.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const editWebsite = async (websiteId, updatedData) => {
        setIsLoading(true);
        try {
            await WebsiteService.editWebsite(websiteId, updatedData);
            refreshWebsites();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteWebsite = async (websiteId) => {
        setIsLoading(true);
        try {
            await WebsiteService.deleteWebsite(websiteId);
            refreshWebsites();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        websites,
        isLoading,
        error,
        addWebsite,
        editWebsite,
        deleteWebsite,
        refreshWebsites
    };
}

export default useManageWebsites;
